import { Loader2 } from "lucide-react";

const SectionFallback = () => (
  <div className="w-full h-full min-h-[400px] flex flex-col items-center justify-center p-8 bg-zinc-900/5 backdrop-blur-md rounded-3xl border border-zinc-800/10 shadow-inner">
    <div className="w-16 h-16 rounded-full bg-zinc-800/10 flex items-center justify-center mb-6 animate-pulse">
      <Loader2 className="w-8 h-8 animate-spin text-zinc-600/50" />
    </div>
    <div className="w-full max-w-md space-y-4">
      <div className="h-4 bg-zinc-800/10 rounded-full animate-pulse w-3/4 mx-auto"></div>
      <div className="h-3 bg-zinc-800/10 rounded-full animate-pulse w-1/2 mx-auto"></div>
    </div>
  </div>
);

export default SectionFallback;
